/* Wagbowl: recipe page reviews (sections/wb-pdp-reviews.liquid), 13 Oct 2026.
   Loads every review from Judge.me's public widget feed (the call Judge.me's own widget makes), re-picks the lead with
   the same rule as the Liquid, fills the "See all reviews" sheet, and opens Judge.me's own form for "Write a review".
   Markup mirrors snippets/wb-review-item.liquid: change one, change both. Any failure leaves the server render alone.
   15 Oct 2026: ONE REVIEW PER PERSON per page (first name + surname initial; the best-ranked stays — same rule as the
   Liquid). FOLLOW: with data-follow the section swaps to the swiped recipe's own reviews on the rooms' "wb:recipe"
   event (detail {id, name, fq}). The sheet never leaves the page locked (any close path, and back/forward cache).
   16 Oct 2026: WRITE A REVIEW in follow mode too. Judge.me's form on the page belongs to the product the page loaded
   with; while the band shows another recipe, the button opens that recipe's own page with ?review=write, which opens
   its form there (one form, always the right product). */
(function () {
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var STAR = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 .9l1.55 3.2 3.5.5-2.53 2.47.6 3.48L6 8.9l-3.12 1.65.6-3.48L.95 4.6l3.5-.5z" fill="currentColor"/></svg>';
  var TICK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 6.3l2.4 2.4 5.2-5.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function when(d) { return d ? MON[+d.slice(5, 7) - 1] + ' ' + d.slice(0, 4) : ''; }
  function dots(s) { var h = ''; for (var i = 1; i <= 5; i++) h += '<i' + (i > s ? ' class="is-off"' : '') + '></i>'; return h; }
  function person(a) { var w = String(a || '').trim().toLowerCase().split(/\s+/); return w[0] + ' ' + (w[1] || '').slice(0, 1); }
  function unlock() { document.documentElement.classList.remove('wb-rv-lock'); }

  function init(root) {
    var ver = (root.dataset.verified || '').split(','), plan = (root.dataset.plan || '').split(',');
    var L = { verified: root.dataset.lVerified, plan: root.dataset.lPlan };
    var lead = root.dataset.lead || '', notes = {}, leads = {}, fq = null, moved = false;   // moved: the band now shows another recipe than it loaded with
    // 16 Oct 2026 (Kevan: "the same reviews are showing in each product and even plan"):
    //  also     {product id: [older product ids]} from each recipe's wagbowl.review_from — a recipe that replaced an older
    //           product (Chicken & Veg with Rice, Grain Free 400g) shows that product's reviews too.
    //  fallback the page's own source (the plan pages: the 1 Month Plan's subscriber reviews), shown only when the
    //           followed recipe has none, instead of an empty band.
    var also = {}, fallback = root.dataset.fallback || '';
    try { also = JSON.parse(root.dataset.also || '{}') || {}; } catch (e) {}
    try { notes = JSON.parse(root.dataset.notes || '{}') || {}; } catch (e) {}
    try { leads = JSON.parse(root.dataset.leads || '{}') || {}; } catch (e) {}
    var names = {};
    try { names = JSON.parse(root.dataset.names || '{}') || {}; } catch (e) {}
    var jm = root.querySelector('[data-rv-jm]');
    var sheet = root.querySelector('[data-rv-sheet]');

    // "Write a review": reveal Judge.me's widget (list and counts hidden by CSS) and open its form.
    var writeBtns = root.querySelectorAll('[data-rv-write]'), home = root.dataset.product, onH = '';
    function jmLink() { return jm && jm.querySelector('.jdgm-write-rev-link'); }
    function wireWrite() {
      if (!jmLink()) return false;
      writeBtns.forEach(function (b) {
        b.hidden = false;
        b.addEventListener('click', function () {
          if (root.dataset.product !== home && onH) { location.assign('/products/' + encodeURIComponent(onH) + '?review=write'); return; }
          if (sheet && sheet.open) closeSheet();
          jm.hidden = false;
          var l = jmLink(); if (l) l.click();
          try { jm.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); } catch (e) {}
        });
      });
      try {   // arrived from "Write a review" on another recipe: open the form once
        var q = new URL(location.href); if (q.searchParams.get('review') === 'write' && writeBtns[0]) { q.searchParams.delete('review'); history.replaceState(history.state, '', q); writeBtns[0].click(); }
      } catch (e) {}
      return true;
    }
    if (!wireWrite()) {   // Judge.me's widget builds its markup after load
      var tries = 0, t = setInterval(function () { if (wireWrite() || ++tries > 20) clearInterval(t); }, 500);
    }

    function badge(r) {
      var star = plan.indexOf(r.id) > -1;
      var lab = star ? L.plan : (ver.indexOf(r.id) > -1 || r.jmVerified) ? L.verified : '';
      if (notes[r.id]) lab = notes[r.id];
      return lab ? ' · <span class="wb-rv__badge">' + (star ? STAR : TICK) + esc(lab) + '</span>' : '';
    }
    function rank(r) {
      if (lead && r.id === lead) return 9;
      var said = (r.title + r.body).length >= 45 || !!r.pic;
      if (!said) return 0;
      if (plan.indexOf(r.id) > -1) return 3;
      if (ver.indexOf(r.id) > -1 || r.jmVerified) return 2;
      return 1;
    }
    function who(r) {
      return '<div class="wb-rv__who"><span class="wb-rv__disc" aria-hidden="true">' + esc((r.author.trim()[0] || '·')) + '</span><span>' +
        '<span class="wb-rv__who-n">' + esc(r.author) + '</span><span class="wb-rv__who-s"><span class="data">' + when(r.date) + '</span>' + badge(r) + '</span></span></div>';
    }
    function quote(r) {
      var q = r.body.length >= 30 ? r.body : (r.title + ' ' + r.body).trim();
      return '<blockquote class="wb-rv__q"><span class="wb-rv__qm" aria-hidden="true">“</span>' +
        (r.pic ? '<img class="wb-rv__qpic" src="' + esc(r.pic) + '" alt="" loading="lazy" decoding="async">' : '') +
        '<p>' + esc(q) + '</p>' + who(r) + '</blockquote>';
    }
    function fqQuote(f) {
      return '<blockquote class="wb-rv__q"><span class="wb-rv__qm" aria-hidden="true">“</span>' +
        (f.pic ? '<img class="wb-rv__qpic" src="' + esc(f.pic) + '" alt="" loading="lazy" decoding="async">' : '') + '<p>' + esc(f.text) + '</p><div class="wb-rv__who"><span class="wb-rv__disc" aria-hidden="true">' +
        esc((f.name || '·')[0]) + '</span><span><span class="wb-rv__who-n">' + esc(f.name || '') + '</span>' + (f.org ? '<span class="wb-rv__who-s">' + esc(f.org) + '</span>' : '') + '</span></div></blockquote>';
    }
    function card(r, cls) {
      return '<article class="' + cls + '"><span class="wb-rv__dots" role="img" aria-label="' + r.score + ' / 5">' + dots(r.score) + '</span>' +
        (r.title ? '<h3>' + esc(r.title) + '</h3>' : '') + (r.body ? '<p>' + esc(r.body) + '</p>' : '') +
        (r.pic ? '<img class="wb-rv__pic" src="' + esc(r.pic) + '" alt="" loading="lazy" decoding="async">' : '') + who(r) + '</article>';
    }

    function parse(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), out = [];
      doc.querySelectorAll('.jdgm-rev').forEach(function (el) {
        var g = function (s) { var n = el.querySelector(s); return n ? n.textContent.trim() : ''; };
        var rt = el.querySelector('.jdgm-rev__rating'), ts = el.querySelector('.jdgm-rev__timestamp'), img = el.querySelector('.jdgm-rev__pic-img');
        out.push({
          id: el.getAttribute('data-review-id') || '', author: names[el.getAttribute('data-review-id')] || g('.jdgm-rev__author'), title: g('.jdgm-rev__title'), body: g('.jdgm-rev__body'),
          score: rt ? +rt.getAttribute('data-score') || 0 : 0, date: ts ? (ts.getAttribute('data-content') || '').slice(0, 10) : '',
          jmVerified: el.getAttribute('data-verified-buyer') === 'true',
          pic: img ? (img.getAttribute('data-src') || '').replace(/([?&])(w|width)=160\b/, '$1$2=600') : ''
        });
      });
      return out;
    }

    function render(all) {
      var grid = root.querySelector('[data-rv-grid]'), empty = root.querySelector('[data-rv-empty]'), open = root.querySelector('[data-rv-open]');
      if (!all.length) {   // follow mode: this recipe has no reviews yet
        if (grid && empty) { grid.hidden = true; empty.hidden = false; var en = empty.querySelector('[data-rv-ename]'); if (en) en.textContent = (empty.dataset.tpl || '').replace('[name]', root.dataset.name || ''); }
        if (open) open.hidden = true;
        return;
      }
      if (grid && empty) { grid.hidden = false; empty.hidden = true; }
      var ordered = all.map(function (r, i) { return { r: r, i: i, k: rank(r) }; })
        .sort(function (a, b) { return b.k - a.k || a.i - b.i; }).map(function (x) { return x.r; });
      var seen = {}, list = ordered.filter(function (r) { var p = person(r.author); if (seen[p]) return false; seen[p] = 1; return true; });   // one per person
      var avg = all.reduce(function (t, r) { return t + r.score; }, 0) / all.length;
      var av = root.querySelector('[data-rv-avg]'), sd = root.querySelector('[data-rv-sdots]'), sa = root.querySelector('[data-rv-savg]'), stt = root.querySelector('[data-rv-stitle]');
      if (av) av.textContent = (Math.round(avg * 10) / 10).toFixed(1);
      if (sa) sa.textContent = (Math.round(avg * 10) / 10).toFixed(1);
      if (sd) sd.innerHTML = dots(Math.round(avg));
      if (stt && root.dataset.follow) stt.textContent = root.dataset.lSheet + ' ' + (root.dataset.name || '');
      var qBox = root.querySelector('[data-rv-quote]'), cBox = root.querySelector('[data-rv-cards]');
      var fixed = moved ? !!(fq && fq.text) : (qBox && qBox.hasAttribute('data-rv-fixed'));   // a featured quote (product metafield) keeps the top spot (16 Oct: also on load in follow mode, e.g. Prime's own page)
      if (qBox) { if (moved && fixed) qBox.innerHTML = fqQuote(fq); else if (!fixed) qBox.innerHTML = quote(list[0]); }
      if (cBox) cBox.innerHTML = list.slice(fixed ? 0 : 1, fixed ? 2 : 3).map(function (r) { return card(r, 'wb-rv__card'); }).join('');
      var lst = root.querySelector('[data-rv-list]');
      if (lst) lst.innerHTML = list.map(function (r) { return card(r, 'wb-rv__row'); }).join('');
      if (open) open.hidden = !(sheet && typeof sheet.showModal === 'function' && list.length > 3);
    }

    function openSheet() { try { sheet.showModal(); document.documentElement.classList.add('wb-rv-lock'); } catch (e) { unlock(); } }
    function closeSheet() { try { sheet.close(); } catch (e) {} unlock(); }
    if (sheet) {
      sheet.addEventListener('close', unlock);
      sheet.addEventListener('cancel', unlock);
      sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
      var x = sheet.querySelector('[data-rv-close]'); if (x) x.addEventListener('click', closeSheet);
      var o = root.querySelector('[data-rv-open]'); if (o) o.addEventListener('click', openSheet);
    }

    var seq = 0;
    function feed(pid) {
      var url = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(root.dataset.shop) +
        '&shop_domain=' + encodeURIComponent(root.dataset.shop) + '&platform=shopify&page=1&per_page=100&product_id=' + encodeURIComponent(pid);
      return fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (j) { return parse(j.html || ''); });
    }
    function load() {
      var my = ++seq, pid = root.dataset.product, ids = [pid].concat(also[pid] || []);
      Promise.all(ids.map(function (id) { return feed(id).catch(function () { return []; }); }))
        .then(function (lists) {
          if (my !== seq) return;
          var all = [].concat.apply([], lists);
          if (!all.length && fallback && fallback !== pid) return feed(fallback).then(function (fb) { if (my === seq) render(fb); });
          render(all);
        })
        .catch(function () { /* keep the server render; the sheet stays hidden */ });
    }
    function follow(d) {
      if (!d || !d.id || String(d.id) === root.dataset.product) return false;
      root.dataset.product = String(d.id); root.dataset.name = d.name || ''; onH = d.handle || ''; moved = true; lead = leads[String(d.id)] || ''; fq = d.fq || null;
      load(); return true;
    }
    if (root.dataset.follow) {
      document.addEventListener('wb:recipe', function (e) { follow(e.detail); });
      if (follow(window.WBRecipe)) return;   // the room / plan top announced its recipe before this script ran
    }
    if (!root.querySelector('[data-rv-quote]') && !(also[root.dataset.product] || []).length) return;   // empty state: nothing to fetch
    load();
  }

  window.addEventListener('pageshow', function () { if (!document.querySelector('dialog.wb-rv__sheet[open]')) unlock(); });
  function boot() { document.querySelectorAll('.wb-rv').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
